export const NAVBAR_ITEMS = [
    {
        'route': '/',
        'name': 'Home',
    },
    {
        'route': '/how-to-play',
        'name': 'How to Play',
    },
    {
        'route': '/game-rules',
        'name': 'Games Rules',
    },
    {
        'route': '/my-skins',
        'name': 'My Skins',
    },
    // {
    //     'route': '/euro-24',
    //     'name': 'EURO 24',
    // },
    /*{
        'route': '/blog',
        'name': 'Blog',
    },*/
];
